module.exports = __webpack_public_path__ + "img/00634453000765.d25fe53d.png";